import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Link from 'next/link';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';
import AspectImage from '@components/Shared/AspectImage/AspectImage';
import { categoryName } from '@utils/studioUtils';
import PostCardStyles from './PostCard.styled';
import { formatHttpsUrl } from '@utils/utils';

const PostCard = ({ post }) => {
  const [imageAspect, setImageAspect] = useState(1);
  const [imageUrl, setImageUrl] = useState('');

  useWindowResize(() => {
    if (window.innerWidth < variables.desktop_breakpoint_extended) {
      setImageAspect(1);
      setImageUrl(
        post.featuredMedia.media.url + '?w=190&h=190&fit=thumb&q=100&fm=webp'
      ); //mobile 95^2
    } else {
      setImageAspect({ width: 390, height: 260 });
      setImageUrl(post.featuredMedia.media.url + '?h=260&q=100&fm=webp');
    }
  }, [variables.desktop_breakpoint_extended]);

  return (
    <PostCardStyles className="post-card">
      <Link href={`/studio/${post.slug}`}>
        <div className="post-image">
          {imageUrl === '' ? (
            ''
          ) : (
            <AspectImage
              behavior="fill-container"
              containerOrientation="landscape"
              aspectRatio={imageAspect}
              src={formatHttpsUrl(imageUrl)}
              alt={post.featuredMedia.altText}
            />
          )}
        </div>
        <div className="post-content">
          <div className="post-subline">
            <span className="label">
              {categoryName(post.postSubcategory)} | {post.tag}
            </span>
          </div>
          <div className="post-headline standard">{post.headline}</div>
        </div>
      </Link>
    </PostCardStyles>
  );
};

PostCard.propTypes = {
  post: PropTypes.shape({
    featuredMedia: PropTypes.shape({
      altText: PropTypes.any,
      media: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
    headline: PropTypes.any,
    postSubcategory: PropTypes.any,
    slug: PropTypes.any,
    tag: PropTypes.any,
  }),
};

export default PostCard;
